import * as featureService from "../Services/serviceLayers";

function contextToLayer_02(data, transportation, time) {
  //console.log("Started");
  //console.log(data, transportation, time);
  let ret = { data: 0, transportation: 0, time: 0 };
  const urls = {
    strava_bike_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/5",
    strava_bike_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/6", //strava dvir, pakeistas
    strava_bike_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/8", //strava dviratininkai, pakeistas
    strava_bike_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/9", // pakeistas
    strava_bike_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/7", 

    waze_jams:
      "https://services1.arcgis.com/usA3lHW20rGU6glp/arcgis/rest/services/waze_jams/FeatureServer/1", // waze duomenys

    strava_pedest_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/0",
    strava_pedest_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/1", //strava pestieji diena, pakeistas
    strava_pedest_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/3", //strava pestieji menesis, pakeistas
    strava_pedest_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/4", // pakeistas
    strava_pedest_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_strava_trips/FeatureServer/2", // pakeistas

    op_car_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/9", // pakeistas
    op_car_day_url:
      "hhttps://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/27", // pakeistas
    op_car_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/15", // pakeistas
    op_car_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/13", // pakeistas
    op_car_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/1", // pakeistas

    op_bike_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/2", // pakeistas
    op_bike_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/1", // pakeistas
    op_bike_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/5", // pakeistas
    op_bike_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/4", // pakeistas
    op_bike_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/3", // pakeistas

    op_pedest_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/18", // pakeistas
    op_pedest_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/17", // pakeistas
    op_pedest_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/21", // pakeistas
    op_pedest_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/20", // pakeistas
    op_pedest_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/19", // pakeistas

    op_bus_hour_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/23", // pakeistas
    op_bus_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/22", // pakeistas
    op_bus_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/26", // pakeistas
    op_bus_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/25", // pakeistas
    op_bus_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/24", // pakeistas

    op_sum_day_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/7", // pakeistas
    op_sum_week_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/28", // pakeistas
    op_sum_month_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/16", // pakeistas
    op_sum_year_url:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/14", // pakeistas

    operator:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/0", // panaikintas
    operatorData:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/32", // panaikintas
    operatorAvailableDates:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/30", // pakeistas
    operatorBikeData:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/31", // panaikintas
    operatorPedestrianData:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/33", // panaikintas
    operatorBusData:
      "https://opencity.idvilnius.lt/atviras/rest/services/Transportas/Judumas_OP_data/FeatureServer/34", // panaikintas



    juduData:
      "https://arcgis.sisp.lt/arcgis/rest/services/VIS/Traffic_Volumes/MapServer/0",
  };

  const urlArr = [
    [
      [
        urls.strava_bike_day_url,
        urls.strava_bike_week_url,
        urls.strava_bike_month_url,
        urls.strava_bike_year_url,
        urls.strava_bike_hour_url,
      ],
      [
        urls.strava_pedest_day_url,
        urls.strava_pedest_week_url,
        urls.strava_pedest_month_url,
        urls.strava_pedest_year_url,
        urls.strava_pedest_hour_url,
      ],
      [],
    ],
    [
      [
        urls.op_bike_day_url,
        urls.op_bike_week_url,
        urls.op_bike_month_url,
        urls.op_bike_year_url,
        urls.op_bike_hour_url,
      ],
      [
        urls.op_pedest_day_url,
        urls.op_pedest_week_url,
        urls.op_pedest_month_url,
        urls.op_pedest_year_url,
        urls.op_pedest_hour_url,
      ],
      [
        urls.op_car_day_url,
        urls.op_car_week_url,
        urls.op_car_month_url,
        urls.op_car_year_url,
        urls.op_car_hour_url,
      ],
      [
        urls.op_bus_day_url,
        urls.op_bus_week_url,
        urls.op_bus_month_url,
        urls.op_bus_year_url,
        urls.op_bus_hour_url,
      ],
      [
        urls.op_sum_day_url,
        urls.op_sum_week_url,
        urls.op_sum_month_url,
        urls.op_sum_year_url,
      ],
    ],
    [
      [urls.operator, urls.operatorPedestrianData, urls.operator],
      [urls.operator, urls.operatorBikeData, urls.operator],
      [urls.operator, urls.operatorData, urls.operator],
      [urls.operator, urls.operatorBusData, urls.operator],
    ],
    [[], [], [urls.juduData, urls.juduData, urls.juduData, urls.juduData]],
  ];
  /*console.log({
    featureLayer: featureService.heatmapArr[data][transportation][time],
    url: urlArr[data][transportation][time],
  });*/
  return {
    featureLayer: featureService.heatmapArr[data][transportation][time],
    url: urlArr[data][transportation][time],
  };
  return {};
}

export default { contextToLayer_02 };
